import styled from "styled-components";

export const Link = styled.div`
  background-color: ${(props) => props.linkBgColor};
  color: ${(props) => props.fontColor};
  border-radius: ${(props) => props.borderStyle};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  width: 400px;
  text-decoration: none;
  transition: 0.3s;
  border: 1px solid ${(props) => props.fontColor};


  &:hover {
    background-color: ${(props) => props.hoverColor};
    color: ${(props) => props.hoverFontColor};
    border: 1px solid ${(props) => props.hoverFontColor};
  }

  .link {
    text-decoration: none;
  }

  .link h2 {
    color: #3c3c3c;
    text-align: center;
  }

  .link a {
    text-decoration: none !important;
  }

  @media (max-width: 550px) {
    .link_div {
      width: 80%;
    }
  }
`;
